import gql from 'graphql-tag'

const GET_TEMPLATE_OVERVIEW = gql`
  query templateOverview($templateCategory: String!) {
    templatesOverview(templateCategory: $templateCategory) {
      id
      name
      templateStatus
      currentQuestionNumber
      isRequired
      hasDeliverable
    }
  }
`

export const STRATEGYBUILDER_SECTION_NAME = {
  BUSINESS_MIX: 'Business Mix & Service Opportunities',
  BRAND_STUDIO_PROFILE: 'Your Brand Studio Profile',
  TARGET_MARKET: 'Target Market',
  MAKERTING_OBJECTIVES: 'Marketing Objectives',
  MARKETING_RESOURCES: 'Marketing Resources',
  BRAND_POSITIONING: 'Brand Positioning',
  MARKETING_GOALS: 'Marketing Goals & Strategies',
  RESOURCE_PLAN: 'Resource Plan',
  MARKETING_PLAN: 'Model Marketing Plan',
}

export const TEMPLATE_CATEGORY = {
  MAINTENANCE_PACKAGE: 'Maintenance Package',
  STRATEGY_BUILDER: 'Strategy Builder',
  ONBOARDING: 'Onboarding',
}
export default GET_TEMPLATE_OVERVIEW
